<template>
    <div>
        <h1>客户信息</h1>
    </div>
</template>
<script>
export default {
    name: "CustomerInfoIndex",
    props: {
        datas: Object,
    },
    data() {
        return {
            rightcom: "CustomerInfoIndex",
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
    h1 {
        color: #333;
    }
</style>
